<template>
  <div>
    <social-sharing
      :url="url"
      :title="title"
      :quote="title"
      :description="description"
      inline-template>
      <div>
        <network network="facebook">
          <img class="social_links" width="40px" height="40px"
               src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/geral/imagens/icon-facebook.png">
        </network>
        <network network="twitter">
          <img class="social_links" width="40px" height="40px"
               src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/geral/imagens/icon-twitter.png">
        </network>
        <network network="whatsapp">
          <img class="social_links" width="40px" height="40px"
               src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/geral/imagens/icon-whats.png">
        </network>
        <network network="linkedin">
          <img class="social_links" width="40px" height="40px"
               src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/geral/imagens/icon-linkedin.png">
        </network>
        <network network="email">
          <img class="social_links" width="40px" height="40px"
               src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/geral/imagens/icon-mail.png">
        </network>
      </div>
    </social-sharing>
  </div>
</template>

<script>
export default {
  name: "LeilaoSocial",
  props: ['title', 'description', 'image', 'url']
}
</script>

<style type="text/css">
.social_links {
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease-in-out;
}

.social_links:hover {
  opacity: 1;
  transition: 0.3s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/social/LeilaoSocial.vue